import { WrapperContent } from "./styled";

interface IIndicationsProps {
  instructionsSummary: string;
}

const Indications = ({ instructionsSummary }: IIndicationsProps) => {
  return (
    <section aria-labelledby="indications-title" className="mt-9 mb-5">
      <h1
        id="indications-title"
        className="text-color-02 font-bold text-subheading-01"
      >
        Indicaciones
      </h1>

      <div className="mt-6">
        <WrapperContent
          id="indications-description"
          className="text-color-01 font-normal text-body-02"
          dangerouslySetInnerHTML={{ __html: instructionsSummary }}
        />
      </div>
    </section>
  );
};

export default Indications;
